/* eslint-disable import/no-default-export */
import { HeaderTestIds } from '@trello/webdriverio-tests';
import { Noun, Verb, trackUe } from '@trello/analytics';
import { MemberAvatar } from 'app/src/components/MemberAvatar';
import { MemberMenuPopoverId } from 'app/gamma/src/components/popovers/popover-ids';
import { getMe, hasGold } from 'app/gamma/src/selectors/members';
import { State } from 'app/gamma/src/modules/types';
import React, {
  lazy,
  Suspense,
  useCallback,
  FunctionComponent,
  useRef,
} from 'react';
import { connect } from 'react-redux';
import { MemberModel } from 'app/gamma/src/types/models';
import HeaderButton from './button';
import styles from './header.less';
import classNames from 'classnames';
import { usePopover } from '../popover';

const HeaderMemberMenuPromise = import(
  /* webpackChunkName: "member-menu-popover" */ 'app/gamma/src/components/popovers/header-member-menu'
);
const HeaderMemberMenu = lazy(() => HeaderMemberMenuPromise);

interface Props {
  hasMemberData: boolean;
  member: MemberModel | undefined;
}

const HeaderMemberMenuButton: FunctionComponent<Props> = ({
  hasMemberData,
  member,
}) => {
  const memberMenuButtonRef = useRef<HTMLButtonElement>(null);
  const { isPopoverShown, showPopover } = usePopover({
    name: MemberMenuPopoverId,
  });
  const onClick = useCallback(() => {
    trackUe({
      category: Noun.HEADER,
      verb: Verb.OPENS,
      directObj: Noun.MEMBER_MENU,
      method: 'by using member menu button in header',
    });
    showPopover();
  }, [showPopover]);
  const { name = '', username = '', id = '', avatarSource = undefined } =
    member || {};
  const userTitle = `${name}${username && ` (${username})`}`;

  return (
    <>
      <HeaderButton
        // this className is needed by Desktop for the My Cards MenuItem
        className={classNames(
          'js-open-header-member-menu',
          styles.memberButton,
        )}
        onClick={onClick}
        ref={memberMenuButtonRef}
        testId={HeaderTestIds.MemberMenuButton}
        title={userTitle}
      >
        <MemberAvatar avatarSource={avatarSource} idMember={id} size={32} />
      </HeaderButton>
      {hasMemberData && isPopoverShown && (
        <Suspense fallback={null}>
          <HeaderMemberMenu target={() => memberMenuButtonRef.current} />
        </Suspense>
      )}
    </>
  );
};

const mapStateToProps = (state: State) => {
  return {
    hasMemberData: !!getMe(state),
    member: getMe(state),
    hasCrown: hasGold(state),
  };
};

export default connect(mapStateToProps)(HeaderMemberMenuButton);
